import { request } from "../_helpers/Auth";

const namespace = "/api";

export const getCategories = () => {
    return request({
        url: namespace + "/categories",
        method: "get",
    });
};

export const getCategory = (category_id) => {
    return request({
        url: namespace + "/category/" + category_id,
        method: "get",
    });
};

export const createCategory = (payload) => {
    return request({
        url: namespace + "/category",
        data: payload,
        method: "post",
    });
};

export const updateCategory = (category_id, payload) => {
    return request({
        url: namespace + "/category/" + category_id,
        data: payload,
        method: "put",
    });
};

export const destroyCategory = (category_id) => {
    return request({
        url: namespace + "/category/" + category_id,
        method: "delete",
    });
};